export const rolesUsers = {
  roles: ["Admin", "MaintenanceManager", "MaintenanceUser"],
  users: {
    Admin: ["Admin 1", "Admin 2"],
    MaintenanceManager: ["Manager 1"],
    MaintenanceUser: ["User 1", "User 2"]
  }
};
